import { useLayoutEffect, useRef } from 'react'

import UIIcon, { UIIconType } from '@/components/UI/UIIcon'
import { useGSAP } from '@/composables/useGSAP'

const colors = [
  {
    color: 'light-blue',
    text: 'text-light-blue',
  },
  {
    color: 'mid-blue',
    text: 'text-mid-blue',
  },
  {
    color: 'scarlet',
    text: 'text-scarlet',
  },
  {
    color: 'peach',
    text: 'text-peach',
  },
  {
    color: 'coral',
    text: 'text-coral',
  },
]

export type UIParticleProps = {
  className?: string
  icon: UIIconType
  color: string
  power: number
  duration: number
}
export default function UIParticle({ className, icon, color, power, duration }: UIParticleProps) {
  const textColor = colors.find((c) => c.color === color).text

  const { gsap } = useGSAP()
  const svgRef = useRef<SVGSVGElement>(null)

  useLayoutEffect(() => {
    if (!svgRef.current) return
    const ctx = gsap.context(() => {
      gsap.set(svgRef.current, { scale: 0, opacity: 0 })
      const angle = Math.random() * 360
      const maxX = window.innerWidth * 0.4
      const maxY = window.innerHeight * 0.4
      const distance = Math.random() * 0.25 + 0.75 * power
      const scale = Math.random() * 1 + 0.5

      const proxy = {
        explosionX: 0,
        explosionY: 0,
        gravityY: 0,
        gravityX: 0,
      }

      gsap
        .timeline({
          onUpdate: () => {
            const x = proxy.explosionX + proxy.gravityX
            const y = proxy.explosionY + proxy.gravityY
            gsap.set(svgRef.current, { x, y })
          },
        })
        // EXPLOSION
        .set(svgRef.current, { opacity: 1 })
        .fromTo(
          svgRef.current,
          {
            scale: 0,
            rotate: Math.random() > 0.5 ? 360 : -360,
            // opacity: 0,
            // opacity: 1,
          },
          {
            scale: scale,
            rotate: 0,
            // opacity: 1,
            duration,
            ease: 'power1.out',
          },
          0
        )
        .to(
          svgRef.current,
          {
            opacity: 0,
            duration: (duration * 1) / 4,
            ease: 'power2.out',
          },
          (duration * 3) / 4
        )
        .fromTo(
          proxy,
          {
            explosionX: 0,
            explosionY: 0,
          },
          {
            explosionX: Math.cos(angle) * maxX * distance,
            explosionY: Math.sin(angle) * maxY * distance,
            duration,
            ease: 'power1.out',
          },
          0
        )
        // GRAVITY
        .fromTo(
          proxy,
          {
            gravityY: 0,
          },
          {
            gravityY: -maxY * 0.3 * (2 - distance) * power,
            duration: (duration * 3) / 5,
            ease: 'power1.out',
          },
          0
        )
        .to(
          proxy,
          {
            gravityY: maxY * 0.05 * distance * power,
            duration: (duration * 2) / 5,
            ease: 'power1.in',
          },
          (duration * 3) / 5
        )
      // .to(
      //   svgRef.current,
      //   {
      //     scale: 0,
      //     opacity: 0,
      //     duration: 1,
      //     ease: 'back.in(1.7)'
      //   }
      // )
    })

    return () => ctx.revert()
  }, [gsap, power, duration])

  return (
    <UIIcon
      ref={svgRef}
      icon={icon}
      className={`absolute top-1/2 left-1/2 -ml-20 -mt-20 ${textColor} ${className ? className : 'text-80'}`}
    />
  )
}
